import type { LocaleObject } from '@nuxtjs/i18n';
import type { ComputedRef } from 'vue';

export function useAvailableLocales(): { availableLocales: ComputedRef<LocaleObject[]> } {
  const config = useRuntimeConfig();
  const { locales } = useEkI18n();

  const availableLocalesFromConfig = config.public.availableLocales as string[];

  const availableLocales = computed(() =>
    locales.value.filter((locale) => availableLocalesFromConfig.includes(locale.code))
  );

  return { availableLocales };
}
